import { createActionGroup, props } from '@ngrx/store';

import { BaseZoneFragment, CommentWithRepliesFragment, JobChangedEvent, JobDetailsV2Fragment,  UpdateJobInput } from '../../../generated/graphql.generated';
import { ActionSource } from '../../state/action-sources';

export type TypedJobChangedEvent<I, O> = {
	input?: I;
	output?: O;
} & Omit<JobChangedEvent, 'input' | 'output'>;

export const JobToolSubscriptionActions = createActionGroup({
	source: ActionSource.JOB_TOOL_SUBSCRIPTION,
	events: {
    // These are called dynamically in src/app/job/job-tool.effects.ts
		'remote job updated': props<TypedJobChangedEvent<UpdateJobInput, {
			job: JobDetailsV2Fragment;
			stageChanged: boolean;
			zone: BaseZoneFragment;
		}>>(),
		'local job updated': props<TypedJobChangedEvent<UpdateJobInput, {
			job: JobDetailsV2Fragment;
			stageChanged: boolean;
			zone: BaseZoneFragment;
		}>>(),
    'Comment Created': props<{
      jobId: string;
      comment: CommentWithRepliesFragment;
    }>(),
    'Comment Updated': props<{
      jobId: string;
      comment: CommentWithRepliesFragment;
    }>(),
    'Comment Deleted': props<{
      jobId: string;
      comment: CommentWithRepliesFragment;
    }>(),
	},
});
